<template>
    <div>
      <div class="landing-page-introduction-box">
        <div class="title">
          <div>
            {{ training_course.name }}
          </div>
        </div>
        <div class="highlight-bar" v-if="training_course.epwin_offer !== null && training_course.epwin_offer !== ''">
          <h1>{{ training_course.epwin_offer }}</h1>
        </div>
        <div class="box-content">
          <div class="mb-3 align-right">
            <button class="btn-primary" @click="openModal()">
              BOOK NOW & MAKE AN ENQUIRY
            </button>
          </div>
          <div v-html="training_course.description"></div>
          <div v-if="training_course.duration !== null && training_course.duration !== ''" class="mt-6">
            <strong>Duration: </strong> {{ training_course.duration }}
          </div>
          <div v-if="training_course.training_course_type !== null" class="mt-2">
            <strong>Type: </strong> {{ training_course.training_course_type.label }}
          </div>
          <div v-if="training_course.minimum_participants !== null && training_course.minimum_participants > 0" class="mt-2">
            <strong>Minimum Participants: </strong> {{ training_course.minimum_participants }}
          </div>
          <div v-if="training_course.maximum_participants !== null && training_course.maximum_participants > 0" class="mt-2">
            <strong>Maximum Participants: </strong> {{ training_course.maximum_participants }}
          </div>
          <div v-if="training_course.full_cost !== null && training_course.full_cost > 0" class="mt-2">
            <strong>Cost: </strong> <s class="txt-danger">£{{ training_course.full_cost }}</s> - <span class="txt-positive">£{{ training_course.epwin_cost }}</span> <span v-if="training_course.training_course_type_id === 3">(per person)</span>
          </div>
          <div class="mt-3 align-right">
            <button class="btn-primary" @click="openModal()">
              BOOK NOW & MAKE AN ENQUIRY
            </button>
          </div>
        </div>
      </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Thank you for your interest</h1>
                </div>
                <div class="modal-content">
                    <p class="mt-0">
                       <strong>Course: '{{ training_course.name }}'</strong>
                    </p>
                    <p>
                        Your enquiry will be sent to our team who will aim to respond within 48 hours, you will be sent a notification when you receive a reply.
                    </p>
                    <p>
                        If you would like to provide some more information please use the box below.
                    </p>
                    <div class="form-group">
                        <strong class="block pl-2 pb-1">Your Message</strong>
                        <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                    </div>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            enquiry_box_open: false,
            enquiry_message: `Course: ${this.training_course.name} - I would like some more information on this course.`,
        }
    },
    props: [
      'logged_in_user',
      'training_course',
    ],
    methods: {
        sendEnquiry() {
            let message = `Course: ${this.training_course.name} - I would like some more information on this course.`;

            if(this.enquiry_message !== '') {
               message = `Course: ${this.training_course.name} - ${this.enquiry_message}`
            }

          axios.post('/training/sendEnquiry', {
            'enquiry_type_id': this.training_course.training_course_category.enquiry_type_id,
            'message': message,
          }).then((response) => {
            this.enquiry_box_open = false;
            Swal.fire({
              title: 'Enquiry Sent',
              icon: 'success',
              text: 'Your Enquiry has been sent, you will be sent a notification when you receive a reply.'
            });
          });
        },
      openModal() {
          this.enquiry_box_open = true;
      },
    },
}
</script>
